import { requestJson } from './client';
import type {
  SessionStatusResponse,
  StartSessionPayload,
  SubmitStepPayload,
  SubmitStepResponse,
  CompleteSurveyResponse,
  SubscribeEmailPayload,
} from '../types/api';

export function getSessionStatus(): Promise<SessionStatusResponse> {
  return requestJson<SessionStatusResponse>('/api/session/status', {
    method: 'GET',
  });
}

export function startSession(payload: StartSessionPayload): Promise<SessionStatusResponse> {
  return requestJson<SessionStatusResponse>('/api/session/start', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function submitSurveyStep(payload: SubmitStepPayload): Promise<SubmitStepResponse> {
  return requestJson<SubmitStepResponse>('/api/survey/step', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function completeSurvey(payload = {}): Promise<CompleteSurveyResponse> {
  return requestJson<CompleteSurveyResponse>('/api/survey/complete', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function subscribeEmail(payload: SubscribeEmailPayload): Promise<unknown> {
  return requestJson('/api/subscribe', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
